document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const panel = document.querySelector('[data-mobile-panel]');

  if (toggle && panel) {
    const closeMenu = () => {
      if (panel instanceof HTMLDialogElement && panel.open) panel.close();
      else panel.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('menu-open');
    };

    toggle.addEventListener('click', () => {
      if (panel instanceof HTMLDialogElement) panel.showModal();
      else panel.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('menu-open');
    });

    panel.querySelector('[data-menu-close]')?.addEventListener('click', closeMenu);
    panel.addEventListener('close', closeMenu);
    panel.addEventListener('click', (event) => {
      if (event.target === panel) closeMenu();
    });
    panel.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
  }

  document.querySelectorAll('.site-nav__details').forEach((details) => {
    details.addEventListener('toggle', () => {
      if (!details.open) return;
      document.querySelectorAll('.site-nav__details[open]').forEach((other) => {
        if (other !== details) other.removeAttribute('open');
      });
    });
  });

  document.addEventListener('click', (event) => {
    document.querySelectorAll('.site-nav__details[open]').forEach((details) => {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.site-nav__details[open]').forEach((details) => {
      details.removeAttribute('open');
      details.querySelector('summary')?.focus();
    });
  });

  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });
  });

  document.querySelectorAll('[data-auto-filter]').forEach((form) => {
    let timer;
    const applyFilters = () => {
      if (!form.reportValidity()) return;
      const url = new URL(form.action, window.location.origin);
      for (const [name, value] of new FormData(form)) {
        if (String(value).trim()) url.searchParams.append(name, value);
      }
      window.location.assign(url.toString());
    };
    const schedule = (delay) => {
      window.clearTimeout(timer);
      timer = window.setTimeout(applyFilters, delay);
    };
    form.addEventListener('input', (event) => {
      if (event.target.matches('input[type="number"]')) schedule(700);
    });
    form.addEventListener('change', () => schedule(180));
    form.addEventListener('submit', (event) => { event.preventDefault(); window.clearTimeout(timer); applyFilters(); });
  });

  document.querySelectorAll('[data-collection-grid]').forEach((grid) => {
    const root = grid.closest('.collection-catalog');
    const buttons = root ? Array.from(root.querySelectorAll('[data-grid-view]')) : [];
    const setView = (view) => {
      grid.dataset.view = view;
      buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.gridView === view)));
    };
    setView(window.matchMedia('(max-width: 699px)').matches ? 'compact' : 'large');
    buttons.forEach((button) => button.addEventListener('click', () => setView(button.dataset.gridView)));
  });

  document.querySelectorAll('[data-filter-drawer]').forEach((drawer) => {
    const id = drawer.id;
    const openTrigger = document.querySelector(`[data-filter-open][aria-controls="${id}"]`);
    const closeTrigger = drawer.querySelector('[data-filter-close]');
    if (openTrigger) openTrigger.addEventListener('click', () => drawer.showModal());
    if (closeTrigger) closeTrigger.addEventListener('click', () => drawer.close());
    drawer.addEventListener('click', (event) => {
      if (event.target === drawer) drawer.close();
    });
  });

  const setupProductGalleries = (scope = document) => {
    const galleries = scope.matches?.('[data-product-gallery]')
      ? [scope]
      : Array.from(scope.querySelectorAll?.('[data-product-gallery]') || []);

    galleries.forEach((gallery) => {
      if (gallery.dataset.galleryReady === 'true') return;
      const wrap = gallery.closest('.product-pdp__gallery-wrap');
      const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
      if (!wrap || slides.length < 2) return;

      const currentLabel = wrap.querySelector('[data-gallery-current]');
      const previousButton = wrap.querySelector('[data-gallery-prev]');
      const nextButton = wrap.querySelector('[data-gallery-next]');
      const dots = Array.from(wrap.querySelectorAll('[data-gallery-dot]'));
      let currentIndex = 0;
      let scrollFrame;
      let dragState;

      gallery.dataset.galleryReady = 'true';
      gallery.querySelectorAll('img').forEach((image) => image.setAttribute('draggable', 'false'));

      const slideLeft = (slide) => (
        slide.getBoundingClientRect().left - gallery.getBoundingClientRect().left + gallery.scrollLeft
      );

      const nearestIndex = () => {
        const left = gallery.scrollLeft;
        const maxLeft = gallery.scrollWidth - gallery.clientWidth;
        return slides.reduce((nearest, slide, index) => (
          Math.abs(Math.min(slideLeft(slide), maxLeft) - left) < Math.abs(Math.min(slideLeft(slides[nearest]), maxLeft) - left) ? index : nearest
        ), 0);
      };

      const updateControls = (index = nearestIndex()) => {
        currentIndex = Math.max(0, Math.min(index, slides.length - 1));
        if (currentLabel) currentLabel.textContent = String(currentIndex + 1).padStart(2, '0');
        if (previousButton) previousButton.disabled = currentIndex === 0;
        if (nextButton) nextButton.disabled = currentIndex === slides.length - 1;
        dots.forEach((dot, dotIndex) => {
          if (dotIndex === currentIndex) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };

      const goTo = (index, behavior = 'smooth') => {
        const nextIndex = Math.max(0, Math.min(index, slides.length - 1));
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) behavior = 'instant';
        gallery.scrollTo({ left: slideLeft(slides[nextIndex]), behavior });
        updateControls(nextIndex);
      };

      previousButton?.addEventListener('click', () => goTo(currentIndex - 1));
      nextButton?.addEventListener('click', () => goTo(currentIndex + 1));
      dots.forEach((dot) => dot.addEventListener('click', () => goTo(Number(dot.dataset.galleryDot))));

      gallery.addEventListener('scroll', () => {
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(() => updateControls());
      }, { passive: true });

      gallery.addEventListener('keydown', (event) => {
        if (event.target !== gallery || gallery.scrollWidth <= gallery.clientWidth) return;
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        goTo(currentIndex + (event.key === 'ArrowRight' ? 1 : -1));
      });

      gallery.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || gallery.scrollWidth <= gallery.clientWidth) return;
        if (event.target.closest('a, button, input, video, model-viewer')) return;
        dragState = { pointerId: event.pointerId, startX: event.clientX, scrollLeft: gallery.scrollLeft };
        gallery.classList.add('is-dragging');
        gallery.setPointerCapture(event.pointerId);
      });

      gallery.addEventListener('pointermove', (event) => {
        if (!dragState || event.pointerId !== dragState.pointerId) return;
        gallery.scrollLeft = dragState.scrollLeft - (event.clientX - dragState.startX);
      });

      const finishDrag = (event) => {
        if (!dragState || event.pointerId !== dragState.pointerId) return;
        dragState = undefined;
        if (gallery.hasPointerCapture(event.pointerId)) gallery.releasePointerCapture(event.pointerId);
        gallery.classList.remove('is-dragging');
        goTo(nearestIndex());
      };

      gallery.addEventListener('pointerup', finishDrag);
      gallery.addEventListener('pointercancel', finishDrag);
      new ResizeObserver(() => goTo(currentIndex, 'auto')).observe(gallery);
      updateControls(0);
    });
  };

  setupProductGalleries();

  const getCartDrawer = () => document.querySelector('[data-cart-drawer]');

  const openCartDrawer = () => {
    const drawer = getCartDrawer();
    if (drawer && !drawer.open) drawer.showModal();
  };

  document.addEventListener('click', (event) => {
    if (event.target.matches('[data-cart-drawer]')) {
      const bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right) event.target.close();
    }
    const openTrigger = event.target.closest('[data-cart-open]');
    if (openTrigger && getCartDrawer()) {
      event.preventDefault();
      openCartDrawer();
      return;
    }

    const closeTrigger = event.target.closest('[data-cart-close]');
    if (closeTrigger) {
      const drawer = closeTrigger.closest('[data-cart-drawer]');
      if (drawer) drawer.close();
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    event.preventDefault();
    const submit = form.querySelector('[type="submit"]');
    if (submit?.disabled || form.dataset.submitting === 'true') return;
    form.dataset.submitting = 'true';
    const errorMessage = form.querySelector('[data-product-error]');
    if (errorMessage) errorMessage.hidden = true;
    if (submit) submit.disabled = true;

    try {
      const data = new FormData(form);
      data.append('sections', 'cart-drawer');
      data.append('sections_url', window.location.pathname);
      const addUrl = new URL(form.action, window.location.origin);
      addUrl.pathname = addUrl.pathname.replace(/\/$/, '') + '.js';
      const response = await fetch(addUrl.toString(), {
        method: 'POST',
        body: data,
        headers: { Accept: 'application/json' }
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || errorMessage?.dataset.cartError);
      const html = result.sections && result.sections['cart-drawer'];
      const cartUrl = new URL(addUrl);
      cartUrl.pathname = cartUrl.pathname.replace(/\/add\.js$/, '');
      cartUrl.search = '';
      if (!html) { window.location.assign(cartUrl.toString()); return; }
      const nextDocument = new DOMParser().parseFromString(html, 'text/html');
      const nextDrawer = nextDocument.querySelector('[data-cart-drawer]');
      const currentDrawer = getCartDrawer();
      if (!nextDrawer || !currentDrawer) { window.location.assign(cartUrl.toString()); return; }
      currentDrawer.replaceWith(nextDrawer);
      document.querySelectorAll('[data-cart-count]').forEach((element) => {
        if (element !== nextDrawer) {
          element.textContent = nextDrawer.dataset.cartCount;
          element.hidden = Number(nextDrawer.dataset.cartCount) === 0;
        }
      });
      openCartDrawer();
    } catch (error) {
      // Never repeat an add request: an interrupted response may still have added the item.
      if (errorMessage) {
        errorMessage.textContent = error.message && !(error instanceof TypeError) ? error.message : errorMessage.dataset.cartError;
        errorMessage.hidden = false;
      }
    } finally {
      delete form.dataset.submitting;
      if (submit) submit.disabled = false;
    }
  });

  const variantRequests = new WeakMap();
  document.addEventListener('change', async (event) => {
    if (!event.target.matches('[data-option-input]')) return;
    const root = event.target.closest('[data-product-root]');
    if (!root) return;
    const values = Array.from(root.querySelectorAll('[data-option-input]:checked'))
      .map((item) => item.dataset.optionValueId)
      .join(',');
    variantRequests.get(root)?.abort();
    const controller = new AbortController();
    variantRequests.set(root, controller);
    const panel = root.querySelector('.product-pdp__panel');
    const submit = panel.querySelector('[type="submit"]');
    const focusedOption = event.target.dataset.optionValueId;
    const errorMessage = panel.querySelector('[data-product-error]');
    panel.setAttribute('aria-busy', 'true');
    if (submit) submit.disabled = true;
    if (errorMessage) errorMessage.hidden = true;
    try {
      const url = new URL(window.location.href);
      url.searchParams.delete('variant');
      url.searchParams.set('section_id', root.dataset.sectionId);
      url.searchParams.set('option_values', values);
      const response = await fetch(url, { signal: controller.signal });
      if (!response.ok) throw new Error('Variant unavailable');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (controller.signal.aborted) return;
      const nextPanel = html.querySelector('[data-product-root] .product-pdp__panel');
      if (!nextPanel) throw new Error('Variant missing');
      panel.replaceWith(nextPanel);
      nextPanel.querySelector(`[data-option-value-id="${CSS.escape(focusedOption)}"]`)?.focus({ preventScroll: true });
      const variant = nextPanel.querySelector('input[name="id"]')?.value;
      if (variant) {
        const productUrl = new URL(window.location.href);
        productUrl.searchParams.set('variant', variant);
        window.history.replaceState({}, '', productUrl);
      }
    } catch (error) {
      if (error.name !== 'AbortError' && errorMessage) {
        errorMessage.textContent = errorMessage.dataset.variantError;
        errorMessage.hidden = false;
      }
    } finally {
      if (variantRequests.get(root) === controller) panel.removeAttribute('aria-busy');
    }
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-quantity-change]');
    if (!button) return;
    const quantity = button.closest('.product-pdp__quantity')?.querySelector('input[type="number"]');
    if (!quantity) return;
    const nextValue = Math.max(Number(quantity.min || 1), Number(quantity.value || 1) + Number(button.dataset.quantityChange));
    quantity.value = String(nextValue);
    quantity.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.querySelectorAll('[data-predictive-search]').forEach((form) => {
    const input = form.querySelector('[data-predictive-search-input]');
    const results = form.querySelector('[data-predictive-search-results]');
    const endpoint = form.dataset.predictiveUrl;
    let timer;
    let searchRequest;
    let useSearchFallback = false;

    const searchFallback = async (query, signal) => {
      const url = new URL(form.action, window.location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[prefix]', 'last');
      url.searchParams.set('section_id', form.dataset.searchSection);
      const response = await fetch(url, { signal });
      if (!response.ok) throw new Error('Search unavailable');
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      const cards = Array.from(page.querySelectorAll('.product-card')).slice(0, 5);
      const list = document.createElement('div');
      list.className = 'predictive-results';
      list.setAttribute('role', 'listbox');
      list.setAttribute('aria-label', results.dataset.suggestionsLabel);
      if (!cards.length) {
        const empty = document.createElement('p');
        empty.className = 'predictive-results__empty';
        empty.textContent = results.dataset.emptyLabel;
        list.append(empty);
      }
      cards.forEach((card) => {
        const productLink = card.querySelector('.product-card__title a');
        if (!productLink) return;
        const link = document.createElement('a');
        link.className = 'predictive-result';
        link.href = productLink.href;
        link.setAttribute('role', 'option');
        const thumbnail = card.querySelector('img');
        if (thumbnail) link.append(thumbnail.cloneNode(true));
        const copy = document.createElement('span');
        const title = document.createElement('strong');
        title.textContent = productLink.textContent;
        const price = document.createElement('small');
        price.textContent = card.querySelector('.product-card__meta > span')?.textContent || '';
        copy.append(title, price);
        link.append(copy);
        list.append(link);
      });
      return list.outerHTML;
    };

    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        window.clearTimeout(timer);
        searchRequest?.abort();
        results.innerHTML = '';
        input.setAttribute('aria-expanded', 'false');
      }
      if (event.key === 'ArrowDown' && results.querySelector('a')) {
        event.preventDefault();
        results.querySelector('a').focus();
      }
    });
    results.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { results.innerHTML = ''; input.setAttribute('aria-expanded', 'false'); input.focus(); }
    });

    input.addEventListener('input', () => {
      window.clearTimeout(timer);
      searchRequest?.abort();
      const query = input.value.trim();
      if (query.length < 2) {
        results.innerHTML = '';
        input.setAttribute('aria-expanded', 'false');
        return;
      }

      timer = window.setTimeout(async () => {
        const controller = new AbortController();
        searchRequest = controller;
        const url = new URL(endpoint, window.location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '5');
        url.searchParams.set('section_id', 'predictive-search');
        try {
          let html;
          if (useSearchFallback) {
            html = await searchFallback(query, controller.signal);
          } else {
            const response = await fetch(url.toString(), { signal: controller.signal });
            if (response.status === 417) {
              useSearchFallback = true;
              html = await searchFallback(query, controller.signal);
            } else {
              if (!response.ok) throw new Error('Suggestions unavailable');
              html = await response.text();
            }
          }
          if (controller.signal.aborted || input.value.trim() !== query) return;
          results.innerHTML = html;
          input.setAttribute('aria-expanded', String(Boolean(html.trim())));
        } catch (error) {
          if (error.name !== 'AbortError') { results.innerHTML = ''; input.setAttribute('aria-expanded', 'false'); }
        }
      }, 220);
    });
  });

  document.querySelectorAll('[data-recently-viewed]').forEach(async (section) => {
    const currentHandle = section.dataset.currentProduct;
    const sectionId = section.dataset.sectionId;
    const grid = section.querySelector('[data-recently-viewed-grid]');
    if (!currentHandle || !sectionId || !grid) return;

    let storedHandles = [];
    try {
      const saved = JSON.parse(window.localStorage.getItem('xingnest:recent-products') || '[]');
      storedHandles = Array.isArray(saved) ? saved.filter((handle) => typeof handle === 'string') : [];
    } catch {
      storedHandles = [];
    }

    const previousHandles = storedHandles.filter((handle) => handle && handle !== currentHandle).slice(0, 4);
    try { window.localStorage.setItem('xingnest:recent-products', JSON.stringify([currentHandle, ...previousHandles].slice(0, 5))); } catch { /* Browsing still works when storage is unavailable. */ }
    grid.innerHTML = '';
    if (!previousHandles.length) return;

    const cards = await Promise.allSettled(previousHandles.map(async (handle) => {
      const response = await fetch(`/products/${encodeURIComponent(handle)}?section_id=${encodeURIComponent(sectionId)}`);
      if (!response.ok) return null;
      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      return documentFragment.querySelector('[data-recently-viewed-card] .product-card');
    }));

    cards.filter((result) => result.status === 'fulfilled' && result.value).forEach((result) => grid.appendChild(result.value));
    section.hidden = grid.children.length === 0;
  });
});
